import { useFormikContext } from "formik";

import * as styledElements from "./FormikErrorMessageStyles";

const FormikErrorMessage = ({
  name,
  errorMessage,
}: {
  name: string;
  errorMessage?: string;
}) => {
  const { getFieldMeta } = useFormikContext();
  const fieldMeta = getFieldMeta(name);

  // for error messages not from the schema
  if (errorMessage) {
    return (
      <styledElements.ErrorField>{errorMessage}</styledElements.ErrorField>
    );
  }

  if (!fieldMeta.touched) {
    return null;
  }

  return (
    <styledElements.ErrorField>{fieldMeta.error}</styledElements.ErrorField>
  );
};

export default FormikErrorMessage;
